import React from 'react';
import cn from 'classnames';

import './fractional.scss';

interface Props {
    value: string;
}

const Fractional: React.FC<Props> = ({ value }) => {
    const [num, denum] = value.split('/');

    return (
        <div
            className="__app-Fractional-container"
            styleName={cn('container', { 'denum-exist': !!denum })}
        >
            <div styleName="num">{num}</div>
            {denum && <div styleName="denum">{denum}</div>}
        </div>
    );
};

export default Fractional;
